import { useRequests } from '../redux/reducer/requests';
import { useUser } from '../redux/reducer/user';
import { defaultStore, stores } from '../translations';

/**
 * Хук для получения текущего кода страны (store) из Redux store
 * @returns {string} - код магазина (ru/kz/ae/qa/sa) или defaultStore
 */
export const useCurrentStore = () => {
  const { appInfoData } = useRequests();
  const { profile } = useUser();

  // Приоритет: профиль пользователя (userCountry) > appInfoData.store
  const userCountry = profile?.userCountry;
  const requestStore = appInfoData?.store;
  const store = userCountry ?? requestStore;

  // Проверяем, что store валидный
  if (store && Object.values(stores).includes(store)) {
    return store;
  }

  return defaultStore;
};
